// extracted by mini-css-extract-plugin
module.exports = {"header":"BrandsHeader_header__eQN8S","trackWrapper":"BrandsHeader_trackWrapper__nWe8k","headingContainer":"BrandsHeader_headingContainer__43BiO"};